const getMyUser = (state) => state.myUser
const getMyUserData = (state) => state.myUser.data

export default {
  getMyUser,
  getMyUserData
}
